// extracted by mini-css-extract-plugin
module.exports = {"card-content-content":"card-content_card-content-content__NBUMC"};